module.exports = __webpack_public_path__ + "img/Mask Group 26.e10c6fca.png";